import {Component} from '@angular/core';
import {Events, NavController, NavParams} from "ionic-angular";
import {TrendingCutPage} from "../../pages/trending-cut/trending-cut";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the TrendingCutsFavouritesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'trending-cuts-favourites',
    templateUrl: 'trending-cuts-favourites.html'
})
export class TrendingCutsFavouritesComponent {

    errors: {};
    loading: boolean;
    tuid: string;
    // Setup empty array of objects to have placeholders on page load
    trendingCuts: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

    constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        this.tuid = localStorage.getItem('tuid');

        events.subscribe('trendingCuts:refresh', () => {
            this.getTrendingCuts().then((trendingCuts) => {
                this.trendingCuts = trendingCuts;
            })
        });

        events.subscribe('trendingCuts:favourite+', (trendingCut) => {
            this.trendingCuts.push(trendingCut);
        });

        events.subscribe('trendingCuts:favourite-', (trendingCut) => {
            let index = this.trendingCuts.findIndex(cut => cut.id === trendingCut.id);
            this.trendingCuts.splice(index, 1);
        });

        events.subscribe('user:login', () => {
            this.tuid = localStorage.getItem('tuid');
            this.getTrendingCuts().then((trendingCuts) => {
                this.trendingCuts = trendingCuts;
            })
        });

        events.subscribe('user:logout', () => {
            this.trendingCuts = null;
        })
    }

    ngOnInit() {
        if (this.tuid) {
            this.loading = true;
            this.getTrendingCuts().then((trendingCuts) => {
                this.trendingCuts = trendingCuts;
            })
        }
    }

    getTrendingCuts() {
        return new Promise((resolve, reject) => {
            this.http.get('/trending-cuts/user/' + this.tuid)
                .subscribe(trendingCuts => {
                    resolve(trendingCuts);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                }, () => {
                    this.loading = false;
                })
        })
    }

    openPage(event: any, trendingCut: object) {
        this.navCtrl.push(TrendingCutPage, {
            trendingCut: trendingCut,
            trendingCuts: this.trendingCuts
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/trending-cuts-favourites/trending-cuts-favourites.ts